import React from 'react';
import { Dropdown } from '../Dropdown';
import { useThemeColor } from '../Theme';
import { getBreadcrumbElementProps } from './Breadcrumb';
import { StyledButton, StyledLink, StyledMoreIcon } from './BreadcrumbOverflow.styled';
export function BreadcrumbOverflow(_ref) {
  var breadcrumbs = _ref.breadcrumbs;
  var actionIconColor = useThemeColor('secondaryActionIcon');
  if (!breadcrumbs.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Dropdown, {
    options: breadcrumbs.map(function (bc) {
      return {
        children: /*#__PURE__*/React.createElement(OverflowItem, bc)
      };
    })
  }, function (buttonProps) {
    return /*#__PURE__*/React.createElement(StyledButton, buttonProps, /*#__PURE__*/React.createElement(StyledMoreIcon, {
      color: actionIconColor
    }));
  });
}
function OverflowItem(props) {
  return /*#__PURE__*/React.createElement(StyledLink, getBreadcrumbElementProps(props), props.title);
}